import React, { useEffect } from "react";
import Presentation from "./Presentation";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import OwlCarousel from "react-owl-carousel";
import { pipViewDate } from "../../../utils/pip";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import NoRecord from "../../../components/other/NoRecord";
import HelpSection from "../../../components/HelpSection";
import {
  fetchLeaguePages,
  fetchleaguePresentation,
  fetchleagueTournaments,
} from "../../../redux/action/getStartAction";

const LeagueTournament = () => {
  const options = {
    loop: true,
    margin: 10,
    nav: true,
    center: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 4,
      },
    },
  };
  const dispatch = useDispatch();
  const { isLoading, leagueData, leagueTournamentsData } = useSelector(
    (state) => state?.getStartReducer
  );

  useEffect(() => {
    dispatch(fetchLeaguePages());
    dispatch(fetchleagueTournaments());
    dispatch(fetchleaguePresentation());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1>{leagueData?.banner_title}</h1>}
        banner_image={leagueData?.banner_image}
        subtitle={leagueData?.banner_text}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Leagues", path: `${pageRoutes?.home}/` },
        ]}
      />
      <HelpSection
        tittle={leagueData?.about_league_title ?? "About Leauge"}
        videoUrl={leagueData?.league_youtube_link}
        thumbnailUrl={leagueData?.league_cover_image}
        media_content={leagueData?.about_league_desc}
      />

      <div className="untree_co-section product-section py-5 ct_league_slider_bg">
        <div className="pb-5">
          <h2 className="section-title mb-2 text-center">
            <strong>{leagueData?.league_page_title}</strong>
          </h2>
          <p className="mb-0 text-center ct_fs_16">
            <div
              dangerouslySetInnerHTML={{ __html: leagueData?.league_page_desc }}
            />
          </p>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              {leagueTournamentsData && leagueTournamentsData?.length > 0 ? (
                <OwlCarousel
                  className="owl-theme ct_league_slider"
                  {...options}
                >
                  {leagueTournamentsData?.map((league, index) => (
                    <div className="item" key={index}>
                      <div className="ct_leauge_card">
                        <figure>
                          <div className="ct_service_img">
                            <img
                              src={league?.banner_image}
                              alt="League Image"
                            />
                          </div>
                          <figcaption>
                            <h4>{league?.tournament_title ?? ""}</h4>
                            <div className="d-flex align-items-center gap-2 justify-content-between flex-wrap mt-3">
                              <div>
                                <p className="mb-0 text-white ct_fs_16">
                                  Start Date
                                </p>
                                <span className="text-white">
                                  {pipViewDate(league?.start_date)}
                                </span>
                              </div>
                              <div>
                                <p className="mb-0 text-white ct_fs_16">
                                  End Date
                                </p>
                                <span className="text-white">
                                  {pipViewDate(league?.end_date)}
                                </span>
                              </div>
                            </div>
                          </figcaption>
                        </figure>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              ) : (
                <NoRecord />
              )}
            </div>
          </div>
        </div>
      </div>
      <Presentation />
      <Footer />
    </div>
  );
};

export default LeagueTournament;
